import { Component, OnInit,Output, EventEmitter } from '@angular/core';
import {FormBuilder,FormGroup,Validators} from '@angular/forms'
import { Router } from '@angular/router';

@Component({
  selector: 'app-city-select',
  templateUrl: './city-select.component.html',
  styleUrls: ['./city-select.component.css']
})
export class CitySelectComponent implements OnInit {

  searchCityForm : FormGroup;

  formFieldValue:boolean = true;

  @Output()
  displayValue : EventEmitter<boolean> = new EventEmitter<boolean>();

  constructor(private formBuilder: FormBuilder,private router:Router) { }

  ngOnInit(): void {
    this.createForm();
  }

  createForm(){
    this.searchCityForm = this.formBuilder.group({
      email:['',[Validators.required]],
      city:['',[Validators.required]],
      myValue:['',[Validators.required]]
    })
  }
  enableButton(){
    console.log('i am called');
    this.formFieldValue=false;
  }
  getValue(){
    console.log('form getting submitted')
    console.log(this.searchCityForm);
    this.displayValue.emit(false);
    this.router.navigate(['/displayWeather',this.searchCityForm.value.city]);
  }
}
